import { ButtonLink } from "design-system/atoms/Button"

import { Outlet, useLocation } from "@tanstack/react-router"
import { BadgePingText } from "design-system/molecules/BadgePingText"
import { Card, CardDescription, CardHeader, CardTitle } from "design-system/molecules/Card"
import { Section } from "design-system/molecules/Section"
import { Pencil } from "lucide-react"
import { useShopifyIntegrationQuery } from "modules/settings/hooks/shopify/useShopifyIntegrationQuery"
import { useTranslation } from "react-i18next"
import { ConvertSizeChartCard } from "./components/ConvertSizeChart"
import { FindOrder } from "./components/findOrder"
import { Metafields } from "./components/Metafields"
import { ShopifyFlows } from "./components/ShopifyFlows"

export const ShopifyIntegration = () => {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const { data } = useShopifyIntegrationQuery()
  const hasConfiguration = data?.shopifyHash
  const isSizeChartRoute = pathname === "/settings/integrations/shopify/SizeChart"
  const disabledReason = t("settings.integrations.disabledRequiresConfiguration")

  if (isSizeChartRoute) {
    return <Outlet />
  }

  return (
    <div className="flex flex-col gap-8">
      <Card>
        <CardHeader className="flex flex-row gap-4 p-4">
          <div className="grow flex flex-col gap-1">
            <CardTitle>{t("settings.integrations.shopify.integrationCard.title")}</CardTitle>
            <CardDescription>
              {hasConfiguration
                ? t("settings.integrations.shopify.integrationCard.descriptionDone")
                : t("settings.integrations.shopify.integrationCard.descriptionPending")}
            </CardDescription>
          </div>
          <div className="flex items-center">
            {hasConfiguration ? (
              <div className="flex gap-2">
                <BadgePingText
                  color={"success"}
                  text={t("settings.integrations.shopify.integrationCard.connected")}
                />
                <ButtonLink
                  variant={"ghost"}
                  size="icon"
                  to="/settings/integrations/shopify/connect"
                >
                  <Pencil />
                </ButtonLink>
              </div>
            ) : (
              <ButtonLink to={"/settings/integrations/shopify/connect"}>
                {t("settings.integrations.shopify.integrationCard.configButton")}
              </ButtonLink>
            )}
          </div>
        </CardHeader>
      </Card>
      {hasConfiguration ? <Metafields /> : null}
      <Section
        title={t("settings.integrations.shopify.flows.title")}
        description={t("settings.integrations.shopify.flows.description")}
      >
        <ShopifyFlows isDisabled={!hasConfiguration} disabledReason={disabledReason} />
      </Section>
      <Section title={t("settings.integrations.bigblue.tools")}>
        <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-4">
          <FindOrder isDisabled={!hasConfiguration} disabledReason={disabledReason} />
          {hasConfiguration && data?.enableSizeCharts ? <ConvertSizeChartCard /> : null}
        </div>
      </Section>
      <Outlet />
    </div>
  )
}
